module.exports = __webpack_public_path__ + "static/media/star_icon.66bf5085.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/star_icon.svg
// module id = 318
// module chunks = 2